export const REQUEST_BANKRUPTCY_SEARCH = 'REQUEST_BANKRUPTCY_SEARCH'
export const RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS'
export const REQUEST_VIEW_SEARCH = 'REQUEST_VIEW_SEARCH'
export const REQUEST_CIVIL_SEARCH = 'REQUEST_CIVIL_SEARCH'
export const REQUEST_CRIMINAL_SEARCH = 'REQUEST_CRIMINAL_SEARCH'
export const RESET_SEARCH_RESULTS = 'RESET_SEARCH_RESULTS'
export const SERVICE_ERROR = 'SERVICE_ERROR'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const RESET_FILTERS = 'RESET_FILTERS'



/** WEBPACK FOOTER **
 ** ./src/constants/pacerSearchConstants.js
 **/